import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import { theme } from "./hoc/Theme";
import { usePageTitle } from "./hoc/Hooks";
import CustomScrollbars from "./CustomScrollbars";
import Footer from "./Footer";
import Header from "./Header";
import { APP_NAME } from "config";
import { useClientViewContext } from "contexts/ClientViewContext";

type LayoutProps = {
  title?: string;
  content?: string;
  noScroll?: boolean;
};

const Layout = ({
  title,
  content,
  children,
  noScroll = false,
}: React.PropsWithChildren<LayoutProps>) => {
  usePageTitle(`${APP_NAME} | ` + (title || ""));
  const inClientView = useClientViewContext();

  if (inClientView) {
    return <>{children}</>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.default",
        }}
      >
        <Header />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            pt: { xs: "64px", md: "88px" },
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            ...(noScroll && {
              maxHeight: { xs: "calc(100vh - 64px - 80px)", md: "calc(100vh - 189px)" },
            }),
            overflow: noScroll ? "hidden" : "hidden",
          }}
        >
          {noScroll ? (
            children
          ) : (
            <CustomScrollbars sx={{ flex: 1, minHeight: 0 }}>
              {children}
            </CustomScrollbars>
          )}
        </Box>

        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default Layout;
